<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable ub ub-ac ub-pc">
          <span class="other-msg"></span>
        </span>
      </div>
      <div class="nav-middle">
        <span>{{nike}}</span>
      </div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>

    <div class="main ub ub-ac ub-pc">
      <div class="seal ub ub-ver ub-ac ub-pc">
        <img src="../../assets/img/封禁.png" />
        <span>该用户已被封禁</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
        nike: "",
    };
  },
  mounted() {
    this.nike=this.$route.params.nike;
  },
  methods: {
    ...mapMutations(["get", "post", "post2"]), //引入方法
    back() {
       this.$router.push({ name: "msg" });
    },
   
  },
};
</script>

<style lang="scss" scoped>
body {
  height: 100%;
  overflow: hidden;
  margin: 0px;
  padding: 0px;
}
.main {
  height: 94%;
  background: #fff;
  position: absolute;
  width: 100%;
  .seal {
    margin-top: -5rem;
    img {
      width: 30%;
      pointer-events: none;
    }
      span {
      font-size: 0.85rem;
      color: #999;
      margin-top: 1.25rem;
    }
  }
}

</style>